import { render, staticRenderFns } from "./VotesResults.vue?vue&type=template&id=9f31cfac&scoped=true"
import script from "./VotesResults.vue?vue&type=script&lang=js"
export * from "./VotesResults.vue?vue&type=script&lang=js"
import style0 from "./VotesResults.vue?vue&type=style&index=0&id=9f31cfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f31cfac",
  null
  
)

export default component.exports